const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'SET_ITINERARY':
            return action.itinerary;

        case 'CLEAR_ITINERARY':
            return INITIAL_STATE;
            
        case 'ITINERARY_TOGGLE_ONE':
            return state.map(day => {
                if(day.id === action.itineraryId) {
                    if(action.open !== null) {
                        day.expanded = action.open;
                    }
                    else {
                        day.expanded = !day.expanded;
                    }
                }
                return day;
            });
            
        case 'ITINERARY_TOGGLE_ALL':
            return state.map(day => {
                day.expanded = action.open;
                return day;
            });

        case 'ITINERARY_SET_SCROLL_TO':
            return state.map(day => {
                if(day.date === action.itineraryDate || day.id === action.itineraryId) {
                    day.expanded = true;
                    day.scrollTo = true;
                }
                else {
                    day.scrollTo = false;
                }
                return day;
            });

        default:
            return state;
    }
}
